export default __webpack_public_path__ + "static/media/vuesax-linear-message-minus.8c49eed2.svg";